module.exports = __webpack_public_path__ + "img/home_modal_poster3.9bf3d392.png";